import { customerPartNumberStyles as customerStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsCustomerPartNumber";
import { manufacturingPartNumberStyles as mfrStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsManufacturingPartNumber";
import { partNumberStyles as partStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPartNumber";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const buildStyling = (style?: TypographyProps) => ({
    ...style,
    css: css`
        ${style?.css}
        margin: 5px 0 3px;
    `,
});

partStyles.valueText = {
    ...buildStyling(partStyles.valueText),
};

customerStyles.valueText = {
    ...buildStyling(customerStyles.valueText),
};

mfrStyles.valueText = {
    ...buildStyling(mfrStyles.valueText),
};
